interface ProcessStep {
  number: string;
  icon: string;
  title: string;
  description: string;
}

interface ProcessSectionProps {
  title?: string;
  subtitle?: string;
  steps: ProcessStep[];
}

export default function ProcessSection({
  title = 'Our Proven Process',
  subtitle = 'Simple, professional, and predictable — from first call to final walkthrough.',
  steps,
}: ProcessSectionProps) {
  return (
    <section className="bg-white py-24 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-slate-100" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-slate-100" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full text-orange-700 text-xs font-bold uppercase tracking-[0.2em] border border-orange-200 bg-orange-50 mb-4">
            How We Work
          </span>
          <h2 className="font-display text-4xl lg:text-5xl font-black text-slate-900 mb-4">{title}</h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">{subtitle}</p>
        </div>

        <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-14 left-[14%] right-[14%] h-px border-t-2 border-dashed border-orange-200 z-0" />

          {steps.map((step, index) => (
            <div key={step.title} className="relative flex flex-col items-center text-center z-10">
              <div className="relative mb-7">
                <div className="relative w-28 h-28 flex items-center justify-center rounded-full border-2 border-orange-200 bg-orange-50">
                  <i className={`${step.icon} text-orange-600 text-3xl`} />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 flex items-center justify-center rounded-full bg-slate-900 text-white text-xs font-black font-display">
                  {String(index + 1).padStart(2, '0')}
                </div>
              </div>

              <div className="px-2">
                <h3 className="font-display text-xl font-bold text-slate-900 mb-3">{step.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{step.description}</p>
              </div>

              {index < steps.length - 1 && (
                <div className="lg:hidden mt-6 w-8 h-8 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-orange-400 text-xl" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
